import { useEffect } from 'react'
import { sanitizeStrings, trackGAEvent } from '@moonpig/web-core-analytics'
import {
  createScreenViewWithProductsGAEvent,
  createViewItemsWithAddonsGAEvent,
} from '@moonpig/web-shared-products'
import { ProductWithRecommendations } from '../../components/ProductDetails'

export const useGATrackingScreenViewWithProductEvent = (
  product: ProductWithRecommendations,
) => {
  useEffect(() => {
    const productData = {
      id: product.id,
      category: sanitizeStrings(product.category.department),
      title: product.title,
      variantTitle: product.masterVariant.title,
      price: product.masterVariant.price.centAmount,
      inStock: product.masterVariant.inStock,
      index: 0,
      isLandscape: product.isLandscape,
      isSponsored: product.isSponsored,
      internallyPromoted: product.internallyPromoted,
    }

    trackGAEvent(
      createScreenViewWithProductsGAEvent({
        product: productData,
      }),
    )

    trackGAEvent(
      createViewItemsWithAddonsGAEvent({
        product: productData,
        variants: product.variants,
        pageLocation: 'product details',
      }),
    )
  }, [product])
}
